import AccountInfo from "./account-info.page";

export default AccountInfo;
